import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Stack,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { authPut } from "../../../util/request/authPut";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ChangeDateTime = (props) => {
  const [open, setOpen] = useState(props.open);
  const [selectedDate, setSelectedDate] = useState(
    dayjs(props.eventData.bookingDetail.party_date)
  );
  const [selectedTime, setSelectedTime] = useState(
    props.eventData.bookingDetail.party_time
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const date = dayjs(selectedDate.format("YYYY-MM-DD"));

  const timeSlots = [
    "10:00",
    "13:00",
    "15:30",
    "16:00",
    "18:00",
    "19:00",
    "20:30",
  ];

  const excludedDaysAndTimes = {
    Mon: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"],
    Tue: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"], // Exclude these times on Tuesday
    Wed: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"],
    Thu: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"], // Exclude these times on Thursday
    Fri: ["10:00", "12:00", "14:00", "16:00", "19:00", "14:00"],
    Sat: ["12:00", "14:00", "15:30", "18:00", "20:00", "20:30"],
    Sun: ["12:00", "14:00", "15:30", "18:00", "20:00", "20:30"], // Exclude these times on Saturday
  };
  const isExcluded = (day, time) => {
    const excludedTimes = excludedDaysAndTimes[day]; // Get excluded times for the selected day
    return excludedTimes?.includes(time); // Check if the time is excluded
  };

  const handleSubmit = async () => {
    const result = await authPut({
      subLink: "booking",
      id: props.eventData._id,
      data: {
        bookingDetail: {
          ...props.eventData.bookingDetail,
          party_date: selectedDate.format("YYYY-MM-DD"),
          party_time: selectedTime
            ? selectedTime
            : props.eventData.bookingDetail.party_time,
        },
      },
    });
    if (result.status === "success") {
      props.reFreshData();

      setOpen(false);
    }

    handleClose();
  };

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          width: "80px",
          height: "15px",
          minWidth: "0px",
          minHeight: "15px",
          paddingLeft: "0px",
          fontSize: "10px", // Adjust text size if needed
          backgroundColor:
            props.eventData.booking_status == "pending"
              ? "#fefefe"
              : props.eventData.package.package_name === "Giant Room" ||
                props.eventData.package.package_name === "Giant Party"
              ? "blue"
              : props.eventData.package.package_name === "Large Room" ||
                props.eventData.package.package_name === "Large Party"
              ? "orange"
              : props.eventData.package.package_name === "Medium Room" ||
                props.eventData.package.package_name === "Medium Party"
              ? "green"
              : "purple",

          color:
            props.eventData.booking_status !== "pending" ? "white" : "gray",
        }}
        // color="wh"
      >
        {props.eventData.package.package_name.slice(0, 1)}
        {["Small Party", "Medium Party", "Large Party", "Giant Party"].includes(
          props.eventData.package.package_name
        )
          ? "*"
          : null}
        {"-"}
        {props.eventData.bookingDetail.celebrant
          .replace(/[^a-zA-Z']/g, "")
          .slice(0, 6)}
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" gutterBottom>
            {props.eventData.bookingDetail.celebrant}'s Party Reschedule
          </Typography>
          <Typography variant="subtitle1" component="h2" gutterBottom>
            {props.eventData.bookingDetail.party_date.slice(5, 10)} at{" "}
            {convertTo12HourTimeCompact(
              props.eventData.bookingDetail.party_time
            )}
          </Typography>
          <Typography
            variant="subtitle1"
            component="h2"
            gutterBottom
            sx={{
              mt: "30px",
              width: "180px",
            }}
          >
            Change to:
          </Typography>
          <Stack>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* <DemoContainer components={["DatePicker"]}> */}
              <DatePicker
                label="Party Date"
                format={"MM/DD/YYYY"}
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(() => e);
                }}
                sx={{
                  mt: "30px",
                  width: "180px",
                }}
              />
              {/* </DemoContainer> */}
            </LocalizationProvider>

            <FormControl variant="standard" sx={{ mt: 1, minWidth: 120 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Party Time
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedTime}
                onChange={(e) => {
                  setSelectedTime(() => e.target.value);
                }}
                label="Time"
                sx={{ width: "200px", marginBottom: "20px" }}
              >
                {timeSlots.map((e) => (
                  <MenuItem key={e} value={e}>
                    {e}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Typography
            variant="subtitle1"
            component="h2"
            sx={{
              my: "10px",
              width: "300px",
            }}
          >
            Please confirm the selected time slot is AVAILABLE and NO confict to
            other parties
          </Typography>

          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="outlined"
              fullWidth
              onClick={handleClose}
              sx={{ maxWidth: "100px", mr: "50px" }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              sx={{ maxWidth: "100px" }}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default ChangeDateTime;
